// src/components/ShipmentTimeline.js
export default function ShipmentTimeline({ timeline = [] }) {
    if (!Array.isArray(timeline)) {
      return (
        <div className="bg-red-100 text-red-700 px-4 py-2 rounded">
          ⚠️ Timeline format is invalid.
        </div>
      );
    }
  
    return (
      <ol className="relative border-l border-gray-300 pl-6">
        {timeline.map((step, index) => (
          <li key={index} className="mb-6">
            <div className="absolute w-3 h-3 bg-brand-teal border-2 border-white rounded-full -left-1.5 top-1" />
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-sm font-semibold text-gray-800">{step.label}</p>
              <p className="text-xs text-gray-500 mt-1">
                {step.timestamp && step.timestamp.seconds
                  ? new Date(step.timestamp.seconds * 1000).toLocaleString()
                  : "⏳ Not yet"}
              </p>
            </div>
          </li>
        ))}
      </ol>
    );
  }
  